import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import cn from "clsx";
import { useAppSelector } from "../../redux/store";
import { selectCdnImageSettings } from "../../util/selectors";
import ContentImage from "../content/contentImage";
import "./style.scss";

type Props = {
  src: string;
  alt?: string;
  withOverlay?: boolean;
  productCount?: number;
  className?: string;
};

const RoundImg: FC<Props> = ({
  src,
  alt,
  withOverlay,
  productCount,
  className
}) => {
  const { t } = useTranslation("orderSuccess");
  const configCdnImagesSettings = useAppSelector(selectCdnImageSettings);

  return (
    <div className={cn("img_round_wrapper", className)}>
      {withOverlay && <div className="img_round_overlay" />}
      {!!productCount && (
        <p className="order_count">
          {" "}
          {`+ ${productCount}`} {t("more")}{" "}
        </p>
      )}
      <ContentImage
        img={src}
        url={configCdnImagesSettings?.myOrder}
        lazyLoad
        alt={alt}
      />
    </div>
  );
};

export default RoundImg;
